module.exports = __webpack_public_path__ + "img/icon-4.6ae7cda9.png";